import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-terms-component',
    templateUrl: './terms-component.component.html',
    styleUrls: ['./terms-component.component.css'],
    standalone: false
})
export class TermsComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
